import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_PAYMENT_LINK_GET',
  GET_SUCCESS: 'STUDENT_PAYMENT_LINK_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_PAYMENT_LINK_GET_FAILURE',

  GET_ALL: 'STUDENT_PAYMENT_LINK_GET_ALL',
  GET_ALL_SUCCESS: 'STUDENT_PAYMENT_LINK_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'STUDENT_PAYMENT_LINK_GET_ALL_FAILURE',

  POST: 'STUDENT_PAYMENT_LINK_POST',
  POST_SUCCESS: 'STUDENT_PAYMENT_LINK_POST_SUCCESS',
  POST_FAILURE: 'STUDENT_PAYMENT_LINK_POST_FAILURE',

  PATCH: 'STUDENT_PATCH',
  PATCH_SUCCESS: 'STUDENT_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_PATCH_FAILURE',

  INVALIDATE_LIST: 'STUDENT_PAYMENT_LINK_INVALIDATE_ALL',
};

export const post = actions.post(
  (id, value, { studentId }) => `${BASE_URL}/students/${studentId}/student-payment-link/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const get = actions.get(
  studentId => `${BASE_URL}/students/${studentId}/student-payment-link/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const getAll = actions.getAll(
  (query, meta) => `${BASE_URL}/students/student-payment-link/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const patch = actions.patch(
  studentId => `${BASE_URL}/students/${studentId}/student-payment-link/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateList = params => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_LIST,
    payload: { params },
  });
};
